import Model, { Integer, IsoDateTime } from 'src/models/model'
import Showing from 'src/models/showing/Showing'

export default class CleanTask extends Model {
  static name = 'CleanTask'

  static noId = true

  static define () {
    this.fields = {
      showing: {
        type: Showing
      },
      earliestStartTime: {
        type: IsoDateTime
      },
      lastestStartTime: {
        type: IsoDateTime
      },
      dueTime: {
        type: IsoDateTime
      },
      scheduledStartTime: {
        type: IsoDateTime
      },
      estimatedDuration: {
        type: Integer
      }
    }

    this.computed = {
      siteEarliestStartTime () {
        return this.earliestStartTime.inTimeZone(this.configuration.currentSite.timeZone)
      },
      siteDueTime () {
        return this.dueTime.inTimeZone(this.configuration.currentSite.timeZone)
      },
      siteScheduledStartTime () {
        return this.scheduledStartTime.inTimeZone(this.configuration.currentSite.timeZone)
      }
    }
  }
}
